import { AxiosResponse } from 'axios';
import { http } from '../http';

export interface CotacaoData {
  numero: number;
  nomeAssociado: string;
  nome: string;
  cpfAssociado: string;
  placa: string;
  marca: string;
  modelo: string;
  ano: number;
  codigoFipe: string;
  valorFipe: string;
  plano: string;
  codigoPlano: string;
  produtos: string[];
  produtosObrigatorios: string[];
  // perfil do veículo para a garantia de compulsórios no backend (at-04)
  codigoCooperativa?: string;
  codigoTipoVeiculo?: string;
  mensalidade: string;
  adesao: string;
  cotaParticipacao: string;
  porcentagemFipe: string;
}

export const gerarCotacaoPDF = async (
  dados: CotacaoData
): Promise<AxiosResponse<{ url: string }>> => {
  return http.post('/cotacao-pdf/gerar', dados);
};
